import { Outlet, Navigate, useLocation } from 'react-router';
import { observer } from 'mobx-react-lite';
import { buildPathWithRedirect } from '@link/share/utils';
import { useStore } from '@link/skytree/stores';

const PrivateRoute = () => {
  const { auth } = useStore();
  const location = useLocation();
  const isLoggedIn = auth.loggedIn;
  if (isLoggedIn) {
    return <Outlet />;
  } else {
    // save full path for redirect after login
    const fullPath = location.pathname + location.search;
    return <Navigate to={buildPathWithRedirect('login', fullPath)} replace />;
  }
};

const ObserverPrivateRoute = observer(PrivateRoute);

export default ObserverPrivateRoute;
